import Vue from 'vue'
import Router from 'vue-router'

// Containers
import TheContainer from "../containers/TheContainer.vue";

// Views
import Dashboard from "../views/Dashboard.vue";

import Colors from "../views/theme/Colors.vue";
import Typography from "../views/theme/Typography.vue";

import Charts from "../views/charts/Charts.vue";
import Widgets from "../views/widgets/Widgets.vue";

// Views - Components
import Cards from "../views/base/Cards.vue";
import Switches from "../views/base/Switches.vue";
import Tabs from "../views/base/Tabs.vue";
import Breadcrumbs from "../views/base/Breadcrumbs.vue";
import Carousels from "../views/base/Carousels.vue";
import Collapses from "../views/base/Collapses.vue";
import Jumbotrons from "../views/base/Jumbotrons.vue";
import ListGroups from "../views/base/ListGroups.vue";
import Navs from "../views/base/Navs.vue";
import Navbars from "../views/base/Navbars.vue";
import Paginations from "../views/base/Paginations.vue";
import Popovers from "../views/base/Popovers.vue";
import ProgressBars from "../views/base/ProgressBars.vue";
import Tables from "../views/tables/Tables.vue";
import AdvancedTables from "../views/tables/AdvancedTables.vue";
import LazyLoadingTables from "../views/tables/LazyLoadingTables.vue";
import LazyLoadingTablesScroll from "../views/tables/LazyLoadingTablesScroll.vue";
import Tooltips from "../views/base/Tooltips.vue";

// Views - Buttons
import StandardButtons from "../views/buttons/StandardButtons.vue";
import ButtonGroups from "../views/buttons/ButtonGroups.vue";
import Dropdowns from "../views/buttons/Dropdowns.vue";
import BrandButtons from "../views/buttons/BrandButtons.vue";

// Views - Editors
import TextEditors from "../views/editors/TextEditors.vue";
import CodeEditors from "../views/editors/CodeEditors.vue";

// Views - Forms
import BasicForms from "../views/forms/Forms.vue";
import AdvancedForms from "../views/forms/AdvancedForms.vue";
import ValidationForms from "../views/forms/ValidationForms.vue";

// Views - GoogleMaps
import GoogleMaps from "../views/GoogleMaps.vue";

// Views - Icons
import CoreUIIcons from "../views/icons/CoreUIIcons.vue";
import Brands from "../views/icons/Brands.vue";
import Flags from "../views/icons/Flags.vue";

// Views - Notifications
import Alerts from "../views/notifications/Alerts.vue";
import Badges from "../views/notifications/Badges.vue";
import Modals from "../views/notifications/Modals.vue";
import Toaster from "../views/notifications/Toaster.vue";

// Views - Pages
import Page404 from "../views/pages/Page404.vue";
import Page500 from "../views/pages/Page500.vue";
import Login from "../views/pages/Login.vue";
import Register from "../views/pages/Register.vue";

// Users
import Users from "../views/users/Users.vue";
import User from "../views/users/User.vue";
import EditUser from "../views/users/EditUser.vue";
import CreateUser from "../views/users/CreateUser.vue";
import DeleteUser from "../views/users/DeleteUser.vue";

// Clients
import Clients from "../views/clients/Clients.vue";
import Client from "../views/clients/Client.vue";
import EditClient from "../views/clients/EditClient.vue";
import CreateClient from "../views/clients/CreateClient.vue";

// Services
import Services from "../views/services/Services.vue";
import Service from "../views/services/Service.vue";
import EditService from "../views/services/EditService.vue";
import CreateService from "../views/services/CreateService.vue";
import ServiceGroups from "../views/services/ServiceGroups.vue";
import Subcategories from "../views/services/Subcategories.vue";
import Subcategory from "../views/services/Subcategory.vue";
import EditSubcategory from "../views/services/EditSubcategory.vue";
import CreateSubcategory from "../views/services/CreateSubcategory.vue";

// Inspectors
import Inspectors from "../views/inspectors/Inspectors.vue";
import Inspector from "../views/inspectors/Inspector.vue";
import EditInspector from "../views/inspectors/EditInspector.vue";
import CreateInspector from "../views/inspectors/CreateInspector.vue";

// ConsultantSellers
import ConsultantSellers from "../views/consultantsSellers/ConsultantSellers.vue";
import ConsultantSeller from "../views/consultantsSellers/ConsultantSeller.vue";
import EditConsultantSeller from "../views/consultantsSellers/EditConsultantSeller.vue";
import CreateConsultantSeller from "../views/consultantsSellers/CreateConsultantSeller.vue";

// Subcontractors
import Subcontractors from "../views/subcontractors/Subcontractors.vue";
import Subcontractor from "../views/subcontractors/Subcontractor.vue";
import EditSubcontractor from "../views/subcontractors/EditSubcontractor.vue";
import CreateSubcontractor from "../views/subcontractors/CreateSubcontractor.vue";

// Invoice Services
import InvoiceServices from "../views/invoiceServices/InvoiceServices.vue";
import EditInvoiceService from "../views/invoiceServices/EditInvoiceService.vue";
import CreateInvoiceService from "../views/invoiceServices/CreateInvoiceService.vue";

// Cases
import Cases from "../views/cases/Cases.vue";
import Case from "../views/cases/Case.vue";
import CreateCase from "../views/cases/CreateCase.vue";
import EditCase from "../views/cases/EditCase.vue";
import ExportCaseDays from "../views/cases/ExportCaseDays.vue";

// Reports
import ReportsUnscheduled from "../views/reports/ReportsUnscheduled.vue";
import ReportsScheduled from "../views/reports/ReportsScheduled.vue";
import ReportsToBeScheduled from "../views/reports/ReportsToBeScheduled.vue";
import InspectorsReports from "../views/reports/InspectorsReports.vue";
import InspectorsFinanceReports from "../views/reports/InspectorsFinanceReports.vue";
import ConsultantsSellersReports from "../views/reports/ConsultantsSellersReports.vue";
import SubcontractorsReports from "../views/reports/SubcontractorsReports.vue";
import ReportsUnbilledCases from "../views/reports/ReportsUnbilledCases.vue";
import ReportsBilledCases from "../views/reports/ReportsBilledCases.vue";
import ReportsZeroBilledCases from "../views/reports/ReportsZeroBilledCases.vue";
import ReportsPartialPayoffCases from "../views/reports/ReportsPartialPayoffCases.vue";
import ReportsFullyPayoffCases from "../views/reports/ReportsFullyPayoffCases.vue";
import ReportsInactiveClients from "../views/reports/ReportsInactiveClients.vue";
import InvoiceReports from "../views/reports/InvoiceReports.vue";
import CertificationReports from "../views/reports/CertificationReports.vue";

// Invoice Clients
import InvoiceClients from "../views/invoiceClients/InvoiceClients.vue";
import InvoiceClient from "../views/invoiceClients/InvoiceClient.vue";
import EditInvoiceClient from "../views/invoiceClients/EditInvoiceClient.vue";
import CreateInvoiceClient from "../views/invoiceClients/CreateInvoiceClient.vue";

// Invoices
import Invoices from "../views/invoice/Invoices.vue";
import Invoices2 from "../views/invoice/Invoices2.vue";
import CreateInvoice from "../views/invoice/CreateInvoice.vue";
import EditInvoice from "../views/invoice/EditInvoice.vue";
import ViewInvoice from "../views/invoice/ViewInvoice.vue";
import CompanyInfo from "../views/invoice/CompanyInfo.vue";
import AddExternalB2GInvoice from "../views/invoice/AddExternalB2GInvoice.vue";
import InvoiceTypeSettings from "../views/invoice/InvoiceTypeSettings.vue";

// Receipt Services
import ReceiptServices from "../views/receiptServices/ReceiptServices.vue";
import EditReceiptService from "../views/receiptServices/EditReceiptService.vue";
import CreateReceiptService from "../views/receiptServices/CreateReceiptService.vue";

// Notes
import Notes from "../views/notes/Notes.vue";
import Note from "../views/notes/Note.vue";
import EditNote from "../views/notes/EditNote.vue";
import CreateNote from "../views/notes/CreateNote.vue";

// Plugins
import Draggable from "../views/plugins/Draggable.vue";
import Calendar from "../views/plugins/Calendar.vue";
import CasesCalendar from "../views/plugins/CasesCalendar.vue";
import Spinners from "../views/plugins/Spinners.vue";

// Views - UI Kits
import Invoice from "../views/apps/invoicing/Invoice.vue";
import Compose from "../views/apps/email/Compose.vue";
import Inbox from "../views/apps/email/Inbox.vue";
import Message from "../views/apps/email/Message.vue";

// Roles
import Roles from "../views/roles/Roles.vue";
import Role from "../views/roles/Role.vue";
import EditRole from "../views/roles/EditRole.vue";
import CreateRole from "../views/roles/CreateRole.vue";

// Bread
import Breads from "../views/bread/Breads.vue";
import Bread from "../views/bread/Bread.vue";
import EditBread from "../views/bread/EditBread.vue";
import CreateBread from "../views/bread/CreateBread.vue";
import DeleteBread from "../views/bread/DeleteBread.vue";

// Resources
import Resources from "../views/resources/Resources.vue";
import CreateResource from "../views/resources/CreateResources.vue";
import Resource from "../views/resources/Resource.vue";
import EditResource from "../views/resources/EditResource.vue";
import DeleteResource from "../views/resources/DeleteResource.vue";

// Email
import Emails from "../views/email/Emails.vue";
import CreateEmail from "../views/email/CreateEmail.vue";
import EditEmail from "../views/email/EditEmail.vue";
import ShowEmail from "../views/email/ShowEmail.vue";
import SendEmail from "../views/email/SendEmail.vue";

// Menus
import Menus from "../views/menu/MenuIndex.vue";
import CreateMenu from "../views/menu/CreateMenu.vue";
import EditMenu from "../views/menu/EditMenu.vue";
import DeleteMenu from "../views/menu/DeleteMenu.vue";

// Menu Elements
import MenuElements from "../views/menuElements/ElementsIndex.vue";
import CreateMenuElement from "../views/menuElements/CreateMenuElement.vue";
import EditMenuElement from "../views/menuElements/EditMenuElement.vue";
import ShowMenuElement from "../views/menuElements/ShowMenuElement.vue";
import DeleteMenuElement from "../views/menuElements/DeleteMenuElement.vue";

// Media
import Media from "../views/media/Media.vue";

// Certifications
import Certifications from "../views/certifications/Certifications.vue";
import CreateCertification from "../views/certifications/CreateCertification.vue";
import EditCertification from "../views/certifications/EditCertification.vue";
import ExportCertifications from "../views/certifications/ExportCertifications.vue";
import ExportCertificationRegistry from "../views/certifications/ExportCertificationRegistry.vue";

// Profile
import EditProfile from "../views/profile/EditProfile.vue";

// Income
import IncomePredict from "../views/tools/IncomePredict.vue";
import IncomePredictOld from "../views/tools/IncomePredictOld.vue";


//InvoiceDashboard
import DashboardInvoice from "../views/DashboardInvoice.vue";

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

/*router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page. 
    if (!localStorage.getItem("api_token")) {
      next({ name: 'Login' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})*/

export default router;

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/login',
      name: 'Αρχική',
      component: TheContainer,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: 'media',
          name: 'Media',
          component: Media
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'colors',
          name: 'Colors',
          component: Colors
        },
        {
          path: 'typography',
          name: 'Typography',
          component: Typography
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'tables',
          redirect: '/tables/tables',
          name: 'Tables',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'tables',
              name: 'Basic tables',
              component: Tables
            },
            {
              path: 'advanced-tables',
              name: 'Advanced tables',
              component: AdvancedTables
            },
            {
              path: 'lazy-loading-tables',
              name: 'Lazy loading tables',
              component: LazyLoadingTables
            },
            {
              path: 'lazy-loading-tables-scroll',
              name: 'Lazy loading tables scroll',
              component: LazyLoadingTablesScroll
            }
          ]
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'menu',
          meta: { label: 'Μενού'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Menus,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Μενού' },
              name: 'CreateMenu',
              component: CreateMenu
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Μενού' },
              name: 'EditMenu',
              component: EditMenu
            },
            {
              path: ':id/delete',
              meta: { label: 'Διαγραφή Μενού' },
              name: 'DeleteMenu',
              component: DeleteMenu
            },
          ]
        },
        {
          path: 'menuelement',
          meta: { label: 'Στοιχεία Μενού'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':menu/menuelement',
              component: MenuElements,
            },
            {
              path: ':menu/menuelement/create',
              meta: { label: 'Καταχώρηση Στοιχείου Μενού' },
              name: 'Create Menu Element',
              component: CreateMenuElement
            },
            {
              path: ':menu/menuelement/:id',
              meta: { label: 'Στοιχείο Μενού'},
              name: 'Menu Element',
              component: ShowMenuElement,
            },
            {
              path: ':menu/menuelement/:id/edit',
              meta: { label: 'Επεξεργασία Στοιχείου Μενού' },
              name: 'Edit Menu Element',
              component: EditMenuElement
            },
            {
              path: ':menu/menuelement/:id/delete',
              meta: { label: 'Διαγραφή Στοιχείου Μενού' },
              name: 'Delete Menu Element',
              component: DeleteMenuElement
            },
          ]
        },
        {
          path: 'users',
          meta: { label: 'Χρήστες'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Χρηστών' },
              name: 'CreateUser',
              component: CreateUser
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Χρήστη'},
              name: 'User',
              component: User,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Χρήστη' },
              name: 'EditUser',
              component: EditUser
            },
            {
              path: ':id/delete',
              meta: { label: 'Διαγραφή Χρήστη' },
              name: 'Delete User',
              component: DeleteUser
            },
          ]
        },
        {
          path: 'profile',
          meta: { label: 'Το προφίλ μου'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':id/edit',
              meta: { label: '' },
              name: 'EditProfile',
              component: EditProfile
            },
          ]
        },
        {
          path: 'clients',
          meta: { label: 'Πελάτες'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Clients,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Πελατών' },
              name: 'CreateClient',
              component: CreateClient
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Πελάτη'},
              name: 'Client',
              component: Client,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Πελάτη' },
              name: 'EditClient',
              component: EditClient
            }
          ]
        },
        {
          path: 'invoice_services',
          meta: { label: 'Υπηρεσίες Τιμολογίων'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: InvoiceServices,
            },
            {
              path: 'create',
              meta: { label: 'Προσθήκη Υπηρεσίας Τιμολογίου' },
              name: 'CreateInvoiceService',
              component: CreateInvoiceService
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Υπηρεσίας Τιμολογίου' },
              name: 'EditInvoiceService',
              component: EditInvoiceService
            }
          ]
        },
        {
          path: 'certifications',
          meta: { label: 'Πιστοποιητικά'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Certifications,
            },
            {
              path: 'create',
              meta: { label: 'Έκδοση Πιστοποιητικού' },
              name: 'CreateCertification',
              component: CreateCertification
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Πιστοποιητικού' },
              name: 'EditCertification',
              component: EditCertification
            },
            {
              path: 'export',
              meta: { label: 'Εξαγωγή Πιστοποιητικών' },
              name: 'ExportCertifications',
              component: ExportCertifications
            },
            {
              path: 'export-registry',
              meta: { label: 'Εξαγωγή Μητρώου Πιστοποιητικών' },
              name: 'ExportCertificationRegistry',
              component: ExportCertificationRegistry
            }
          ]
        },
        {
          path: 'services',
          meta: { label: 'Υπηρεσίες'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Services,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Υπηρεσίας' },
              name: 'CreateService',
              component: CreateService
            },
            {
              path: 'groups',
              meta: { label: 'Ομάδες Υπηρεσιών' },
              name: 'ServiceGroups',
              component: ServiceGroups
            },
            {
              path: 'create_subcategory',
              meta: { label: 'Καταχώρηση Υποκατηγορίας' },
              name: 'CreateSubcategory',
              component: CreateSubcategory
            },
            {
              path: 'subcategory',
              meta: { label: 'Υποκατηγορίες'},
              name: 'Subcategories',
              component: Subcategories,
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Υπηρεσίας'},
              name: 'Service',
              component: Service,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Υπηρεσίας' },
              name: 'EditService',
              component: EditService
            },
            {
              path: 'subcategory/:id',
              meta: { label: 'Στοιχεία Υποκατηγορίας'},
              name: 'Subcategory',
              component: Subcategory,
            },
            {
              path: 'subcategory/:id/edit',
              meta: { label: 'Επεξεργασία Υποκατηγορίας' },
              name: 'EditSubcategory',
              component: EditSubcategory
            }
          ]
        },
        {
          path: 'inspectors',
          meta: { label: 'Επιθεωρητές'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Inspectors,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Επιθεωρητή' },
              name: 'CreateInspector',
              component: CreateInspector
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Επιθεωρητή'},
              name: 'Inspector',
              component: Inspector,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Επιθεωρητή' },
              name: 'EditInspector',
              component: EditInspector
            }
          ]
        },
        {
          path: 'consultantSellers',
          meta: { label: 'Σύμβουλοι - Πωλητές'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ConsultantSellers,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Συμβούλου - Πωλητή' },
              name: 'CreateConsultantSeller',
              component: CreateConsultantSeller
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Συμβούλου - Πωλητή'},
              name: 'ConsultantSeller',
              component: ConsultantSeller,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Συμβούλου - Πωλητή' },
              name: 'EditConsultantSeller',
              component: EditConsultantSeller
            }
          ]
        },
        {
          path: 'Subcontractors',
          meta: { label: 'Υπεργολάβοι'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Subcontractors,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Υπεργολάβου' },
              name: 'CreateSubcontractor',
              component: CreateSubcontractor
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Υπεργολάβου'},
              name: 'Subcontractor',
              component: Subcontractor,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Υπεργολάβου' },
              name: 'EditSubcontractor',
              component: EditSubcontractor
            }
          ]
        },
        {
          path: 'cases',
          meta: { label: 'Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Cases,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Υπόθεσης' },
              name: 'CreateCase',
              component: CreateCase
            },
            {
              path: 'export-days',
              meta: { label: 'Εξαγωγή Ημερών Επιθεώρησης' },
              name: 'ExportCaseDays',
              component: ExportCaseDays
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Υπόθεσης'},
              name: 'Case',
              component: Case,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Υπόθεσης' },
              name: 'EditCase',
              component: EditCase
            }
          ]
        },
        {
          path: 'inspectors-financial-reports',
          name: 'Επιθεωρητές - Ποσά',
          component: InspectorsFinanceReports
        },
        {
          path: 'unscheduled-reports',
          meta: { label: 'Απρογραμμάτιστες Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsUnscheduled,
            }
          ]
        },
        {
          path: 'scheduled-reports',
          meta: { label: 'Προγραμματισμένες Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsScheduled,
            }
          ]
        },
        {
          path: 'to-be-scheduled-reports',
          meta: { label: 'Προς Προγραμματισμό Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsToBeScheduled,
            }
          ]
        },
        {
          path: 'reports-for-inspectors',
          meta: { label: 'Αναφορά Επιθεωρητών'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: InspectorsReports,
            }
          ]
        },
        {
          path: 'reports-for-consultantsSellers',
          meta: { label: 'Αναφορά Συμβούλων - Πωλητών'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ConsultantsSellersReports,
            }
          ]
        },
        {
          path: 'reports-for-subcontractors',
          meta: { label: 'Αναφορά Υπεργολάβων'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: SubcontractorsReports,
            }
          ]
        },
        {
          path: 'unbilled-cases-reports',
          meta: { label: 'Μη Τιμολογημένες Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsUnbilledCases,
            }
          ]
        },
        {
          path: 'billed-cases-reports',
          meta: { label: 'Τιμολογημένες Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsBilledCases,
            }
          ]
        },
        {
          path: 'partial-payoff-cases-reports',
          meta: { label: 'Μερικώς Εξοφλημένες Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsPartialPayoffCases,
            }
          ]
        },
        {
          path: 'fully-payoff-cases-reports',
          meta: { label: 'Πλήρως Εξοφλημένες Υποθέσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsFullyPayoffCases,
            }
          ]
        },
        {
          path: 'zero-billed-cases-reports',
          meta: { label: 'Τιμολογημένες Υποθέσεις με Μηδενικό Ποσό'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsZeroBilledCases,
            }
          ]
        },
        {
          path: 'inactive-clients-reports',
          meta: { label: 'Ανενεργοί Πελάτες'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportsInactiveClients,
            }
          ]
        },
        {
          path: 'invoice-reports',
          meta: { label: 'Αναφορές Τιμολογίων'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: InvoiceReports,
            }
          ]
        },
        {
          path: 'certification-reports',
          meta: { label: 'Αναφορές Πιστοποιητικών'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: CertificationReports,
            }
          ]
        },
        {
          path: 'invoiceClients',
          meta: { label: 'Πελάτες Τιμολογίου'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: InvoiceClients,
            },
            {
              path: 'create',
              meta: { label: 'Προσθήκη Πελάτη Τιμολογίου' },
              name: 'CreateInvoiceClient',
              component: CreateInvoiceClient
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Πελάτη Τιμολογίου'},
              name: 'InvoiceClient',
              component: InvoiceClient,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Πελάτη Τιμολογίου' },
              name: 'EditInvoiceClient',
              component: EditInvoiceClient
            }
          ]
        },
        {
          path: 'invoices',
          meta: { label: 'Τιμολόγια'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Invoices,
            },
            {
              path: 'v2',
              component: Invoices2,
            },
            {
              path: 'create',
              meta: { label: 'Έκδοση Τιμολογίου' },
              component: CreateInvoice,
            },
            {
              path: 'add-external-b2g',
              meta: { label: 'Καταχώρηση Εξωτερικού B2G Τιμολογίου' },
              name: 'AddExternalB2GInvoice',
              component: AddExternalB2GInvoice,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Τιμολογίου' },
              name: 'EditInvoice',
              component: EditInvoice
            },
            {
              path: 'company_info',
              meta: { label: 'Στοιχεία Εταιρείας' },
              component: CompanyInfo,
            },
            {
              path: 'settings',
              meta: { label: 'Ρυθμίσεις Τύπων Παραστατικών' },
              name: 'InvoiceTypeSettings',
              component: InvoiceTypeSettings,
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Τιμολογίου'},
              name: 'ViewInvoice',
              component: ViewInvoice,
            },
          ],
        },
        // {
        //   path: 'receipts',
        //   meta: { label: 'Αποδείξεις Πληρωμής'},
        //   component: {
        //     render (c) { return c('router-view') }
        //   },
        //   children: [
        //     {
        //       path: '',
        //       component: Receipts,
        //     },
        //     {
        //       path: 'create',
        //       meta: { label: 'Έκδοση απόδειξης' },
        //       component: CreateReceipt,
        //     },
        //     {
        //       path: ':id/edit',
        //       meta: { label: 'Επεξεργασία απόδειξης' },
        //       name: 'EditReceipt',
        //       component: EditReceipt
        //     },
        //     {
        //       path: ':id',
        //       meta: { label: 'Στοιχεία απόδειξης'},
        //       name: 'ViewReceipt',
        //       component: ViewReceipt,
        //     },
        //   ],
        // },
        {
          path: 'receipt_services',
          meta: { label: 'Υπηρεσίες Απόδειξης'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReceiptServices,
            },
            {
              path: 'create',
              meta: { label: 'Προσθήκη Υπηρεσίας Απόδειξης' },
              name: 'CreateReceiptService',
              component: CreateReceiptService
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Υπηρεσίας Απόδειξης' },
              name: 'EditReceiptService',
              component: EditReceiptService
            }
          ]
        },
        {
          path: 'notes',
          meta: { label: 'Σημειώσεις'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Notes,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Σημείωσης' },
              name: 'CreateNote',
              component: CreateNote
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Σημείωσης'},
              name: 'Note',
              component: Note,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Σημείωσης' },
              name: 'EditNote',
              component: EditNote
            },
          ]
        },
        {
          path: 'roles',
          meta: { label: 'Ρόλοι'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Roles,
            },
            {
              path: 'create',
              meta: { label: 'Καταχώρηση Ρόλου' },
              name: 'Create Note',
              component: CreateRole
            },
            {
              path: ':id',
              meta: { label: 'Στοιχεία Ρόλου'},
              name: 'Role',
              component: Role,
            },
            {
              path: ':id/edit',
              meta: { label: 'Επεξεργασία Ρόλου' },
              name: 'Edit Role',
              component: EditRole
            },
          ]
        },
        {
          path: 'bread',
          meta: { label: 'Bread'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Breads,
            },
            {
              path: 'create',
              meta: { label: 'Create Bread' },
              name: 'CreateBread',
              component: CreateBread
            },
            {
              path: ':id',
              meta: { label: 'Bread Details'},
              name: 'Bread',
              component: Bread,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Bread' },
              name: 'Edit Bread',
              component: EditBread
            },
            {
              path: ':id/delete',
              meta: { label: 'Delete Bread' },
              name: 'Delete Bread',
              component: DeleteBread
            },
          ]
        },
        {
          path: 'email',
          meta: { label: 'Emails'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Emails,
            },
            {
              path: 'create',
              meta: { label: 'Create Email Template' },
              name: 'Create Email Template',
              component: CreateEmail
            },
            {
              path: ':id',
              meta: { label: 'Show Email Template'},
              name: 'Show Email Tempalte',
              component: ShowEmail,
            },
            {
              path: ':id/edit',
              meta: { label: 'Edit Email Tempalate' },
              name: 'Edit Email Template',
              component: EditEmail
            },
            {
              path: ':id/sendEmail',
              meta: { label: 'Send Email' },
              name: 'Send Email',
              component: SendEmail
            },
          ]
        },
        {
          path: 'resource',
          meta: { label: 'Resources'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: ':bread/resource',
              component: Resources,
            },
            {
              path: ':bread/resource/create',
              meta: { label: 'Create Resource' },
              name: 'CreateResource',
              component: CreateResource
            },
            {
              path: ':bread/resource/:id',
              meta: { label: 'Resource Details'},
              name: 'Resource',
              component: Resource,
            },
            {
              path: ':bread/resource/:id/edit',
              meta: { label: 'Edit Resource' },
              name: 'Edit Resource',
              component: EditResource
            },
            {
              path: ':bread/resource/:id/delete',
              meta: { label: 'Delete Resource' },
              name: 'Delete Resource',
              component: DeleteResource
            },
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'breadcrumb',
              name: 'Breadcrumb',
              component: Breadcrumbs
            },
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'carousel',
              name: 'Carousel',
              component: Carousels
            },
            {
              path: 'collapse',
              name: 'Collapse',
              component: Collapses
            },
            {
              path: 'jumbotron',
              name: 'Jumbotron',
              component: Jumbotrons
            },
            {
              path: 'list-group',
              name: 'List Group',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'pagination',
              name: 'Pagination',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress',
              name: 'Progress',
              component: ProgressBars
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-group',
              name: 'Button Group',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'editors',
          redirect: '/editors/text-editors',
          name: 'Editors',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'text-editors',
              name: 'Text Editors',
              component: TextEditors
            },
            {
              path: 'code-editors',
              name: 'Code Editors',
              component: CodeEditors
            }
          ]
        },
        {
          path: 'forms',
          redirect: '/forms/basic-forms',
          name: 'Forms',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'basic-forms',
              name: 'Basic Forms',
              component: BasicForms
            },
            {
              path: 'advanced-forms',
              name: 'Advanced Forms',
              component: AdvancedForms
            },
            {
              path: 'validation-forms',
              name: 'Form Validation',
              component: ValidationForms
            }
          ]
        },
        {
          path: 'google-maps',
          name: 'Google Maps',
          component: GoogleMaps
        },
        {
          path: 'icon',
          redirect: '/icon/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Standard CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badge',
              name: 'Badge',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            },
            {
              path: 'toaster',
              name: 'Toaster',
              component: Toaster
            }
          ]
        },
        {
          path: 'casescalendar',
          name: 'Ημερολόγιο Υποθέσεων',
          component: CasesCalendar
        },
        {
          path: 'income/predict',
          name: 'incomePredit',
          component: IncomePredict
        },
        {
          path: 'income/predict/old',
          name: 'incomePredictOld',
          component: IncomePredictOld
        },
        {
          path: 'dashboard/invoice',
          name: 'dashboardInvoice',
          component: DashboardInvoice
        },
        {
          path: 'plugins',
          redirect: '/plugins/draggable',
          name: 'Plugins',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'draggable',
              name: 'Draggable Cards',
              component: Draggable
            },
            {
              path: 'calendar',
              name: 'Calendar',
              component: Calendar
            },
            {
              path: 'spinners',
              name: 'Spinners',
              component: Spinners
            }
          ]
        },
       
        {
          path: 'apps',
          name: 'Apps',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'invoicing',
              redirect: '/apps/invoicing/invoice',
              name: 'Invoicing',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'invoice',
                  name: 'Invoice',
                  component: Invoice
                }
              ]
            },
            {
              path: 'email',
              redirect: '/apps/email/inbox',
              name: 'Email',
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'compose',
                  name: 'Compose',
                  component: Compose
                },
                {
                  path: 'inbox',
                  name: 'Inbox',
                  component: Inbox
                },
                {
                  path: 'message',
                  name: 'Message',
                  component: Message
                }
              ]
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
      ]
    },
    {
      path: '/',
      redirect: '/login',
      name: 'Auth',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
      ]
    },
    {
      path: '*',
      name: '404',
      component: Page404
    }
  ]
}

